import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

const ContentItem = ({ title, value, isHeader, withoutMargin, isFullWidth }) => {
    return (
        <li
            className={cn(styles.item, {
                [styles["item--header"]]: isHeader,
                [styles["item--withoutMargin"]]: withoutMargin,
                [styles["item--fullWidth"]]: isFullWidth,
            })}
        >
            {title && <p className={styles.item__title}>{title}</p>}
            {Array.isArray(value) ? (
                <>
                    {value.map((item, index) => (
                        <span key={index} className={styles.item__itemValue}>
                            {item}
                        </span>
                    ))}
                </>
            ) : (
                <span className={styles.item__itemValue}>{value}</span>
            )}
        </li>
    );
};

export default ContentItem;
